import styled from 'styled-components';

import { theme } from '_constants/theme';

import Text from '_components/atomic/layouts/Card/Text';
import FeedbackSwiper from './FeedbackSwiper';

const StyledOuterContainer = styled.div`
  max-width: ${theme.spaces.large32X * 10}px;
  width: 100%;
  position: relative;

  @media ${theme.devices.tablet} {
  }
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 768px;
  padding-top: ${theme.spaces.large14X}px;
  padding-bottom: ${theme.spaces.large14X}px;
  padding-left: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
  border-top-right-radius: 32px;
  border-bottom-left-radius: 32px;
  border: 1px solid ${theme.colors.gray[200]};
  background-color: ${theme.colors.gray[50]};

  position: relative;

  @media ${theme.devices.tablet} {
    border-radius: unset;
    padding-top: ${theme.spaces.large12X}px;
    padding-bottom: ${theme.spaces.large12X}px;
    border-bottom: unset;
  }
`;

const StyledCurve1 = styled.div`
  height: ${theme.spaces.large28X}px;
  margin-top: ${theme.spaces.large16X}px;
  width: 100%;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: -1px;
    height: 100%;
    width: 50%;
    border-top-left-radius: 32px;
    border-top: 1px solid ${theme.colors.gray[200]};
    border-left: 1px solid ${theme.colors.gray[200]};
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: -100%;
    height: 100%;
    width: 50%;
    border-bottom-right-radius: 32px;
    border-bottom: 1px solid ${theme.colors.gray[200]};
  }

  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const StyledLine1 = styled.div`
  display: block;
  position: absolute;
  right: -35px;
  top: 21px;
  height: 32px;
  width: 100px;
  border-top-right-radius: 32px;
  border-top: 1px solid ${theme.colors.gray[200]};
  transform: rotate(90deg);

  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const StyledCurve2 = styled.div`
  height: ${theme.spaces.large28X}px;
  width: 100%;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 100%;
    height: 100%;
    width: 50%;
    border-top-left-radius: 32px;
    border-top: 1px solid ${theme.colors.gray[200]};
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 1px;
    height: 100%;
    width: 50%;
    border-bottom-right-radius: 32px;
    border-right: 1px solid ${theme.colors.gray[200]};
    border-bottom: 1px solid ${theme.colors.gray[200]};
  }

  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const CustomerFeedbackSection = () => {
  return (
    <StyledOuterContainer>
      <StyledCurve1 />
      <StyledLine1 />
      <StyledInnerContainer>
        <Text
          size={theme.fontSizes.large11X}
          bottomSpace={theme.spaces.large14X}
          desktop
        >
          Why Do Our Customers Love Us?
        </Text>
        <Text
          size={theme.fontSizes.large8X}
          bottomSpace={theme.spaces.large12X}
          centered
          mobile
        >
          Why Do Our Customers Love Us?
        </Text>
        <FeedbackSwiper />
      </StyledInnerContainer>
      <StyledCurve2 />
    </StyledOuterContainer>
  );
};

export default CustomerFeedbackSection;
